/* @flow */

export default {
  BUS: 'BUS',
  PASSENGER_CAR: 'PASSENGER-CAR',
  TRUCK: 'TRUCK',
  UNIMOG: 'UNIMOG',
  VAN: 'VAN'
};
